'use strict';

var base = require('base/login/login');
var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');

/**
 * Refresh the reCAPTCHA Enterprise token for a form before AJAX submission.
 * If reCAPTCHA Enterprise is not loaded on the page, the callback fires immediately.
 *
 * @param {jQuery} $form - jQuery form element
 * @param {string} action - reCAPTCHA action name (e.g. 'LOGIN', 'REGISTER')
 * @param {Function} callback - called once the token is refreshed
 */
function refreshRecaptcha($form, action, callback) {
    if (typeof window.refreshRecaptchaToken === 'function') {
        window.refreshRecaptchaToken($form[0], callback);
    } else {
        callback();
    }
}

/**
 * Submit the login form via AJAX (extracted to allow token refresh before send).
 *
 * @param {jQuery} form - jQuery form element
 * @param {jQuery} card - card wrapper for spinner
 */
function submitLogin(form, card) {
    var url = form.attr('action');
    card.spinner().start();
    $('form.login').trigger('login:submit');
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            card.spinner().stop();
            if (!data.success) {
                formValidation(form, data);
                $('form.login').trigger('login:error', data);
            } else if (data.success && (data.queryString === 'productId=undefined' || data.queryString === 'rurl=1' || data.queryString === 'rurl=2')) {
                $('form.login').trigger('login:success', data);
                location.href = data.redirectUrl;
            } else if (data.success && data.queryString !== 'productId=undefined') {
                $('form.login').trigger('login:success', data);
                $.ajax({
                    url: data.redirectUrl,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success: function (result) {
                        card.spinner().stop();
                        if (!result.success) {
                            formValidation(form, result);
                        } else {
                            location.href = result.productRedirectUrl;
                        }
                    }
                });
            } else {
                $('form.login').trigger('login:success', data);
                location.href = data.redirectUrl;
            }
        },
        error: function (data) {
            if (data.responseJSON.redirectUrl) {
                window.location.href = data.responseJSON.redirectUrl;
            } else {
                $('form.login').trigger('login:error', data);
                card.spinner().stop();
            }
        }
    });
}

/**
 * Submit the registration form via AJAX (extracted to allow token refresh before send).
 *
 * @param {jQuery} form - jQuery form element
 * @param {jQuery} card - card wrapper for spinner
 */
function submitRegistration(form, card) {
    var url = form.attr('action');
    card.spinner().start();
    $('form.registration').trigger('login:register');
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            card.spinner().stop();
            if (!data.success) {
                $('form.registration').trigger('login:register:error', data);
                formValidation(form, data);
            } else if (data.success && (data.queryString === 'productId=undefined' || data.queryString === 'rurl=1' || data.queryString === 'rurl=2')) {
                $('form.registration').trigger('login:register:success', data);
                location.href = data.redirectUrl;
            } else if (data.success && data.queryString !== 'productId=undefined') {
                $('form.registration').trigger('login:register:success', data);
                $.ajax({
                    url: data.redirectUrl,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success: function (result) {
                        card.spinner().stop();
                        if (!result.success) {
                            formValidation(form, result);
                        } else {
                            location.href = result.productRedirectUrl;
                        }
                    }
                });
            } else {
                $('form.registration').trigger('login:register:success', data);
                location.href = data.redirectUrl;
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
            }

            card.spinner().stop();
        }
    });
}

base.login = function () {
    $('form.login').submit(function (e) {
        var form = $(this);
        var card = form.closest('.card');
        e.preventDefault();

        // Refresh the reCAPTCHA Enterprise token before each AJAX submit
        // (Enterprise tokens are single-use)
        refreshRecaptcha(form, 'LOGIN', function () {
            submitLogin(form, card);
        });

        return false;
    });
};

base.register = function () {
    $('form.registration').submit(function (e) {
        var form = $(this);
        var card = form.closest('.card');
        e.preventDefault();

        // Refresh the reCAPTCHA Enterprise token before each AJAX submit
        // (Enterprise tokens are single-use)
        refreshRecaptcha(form, 'REGISTER', function () {
            submitRegistration(form, card);
        });

        return false;
    });
};

module.exports = base;
